export type InviteStyle = "friendly" | "trash-talk" | "mystery";

export interface ShareInviteOptions {
  competitionName: string;
  inviterName: string;
  inviterSteps?: number;
  inviteCode: string;
  inviterId: string;
  host?: string;
}

export interface ShareData {
  title: string;
  text: string;
  url: string;
}

export function getShareInviteData(
  opts: ShareInviteOptions,
  style: InviteStyle = "friendly",
): ShareData {
  const host = opts.host ?? "https://footslapping.com";
  const url = `${host}/invite/${opts.inviteCode}?ref=${opts.inviterId}`;

  switch (style) {
    case "trash-talk":
      return {
        title: `🔥 Step Challenge: ${opts.competitionName}`,
        text: `💪 Think you can keep up? ${opts.inviterName} is at ${opts.inviterSteps ?? 0} steps already. Accept the challenge →`,
        url,
      };
    case "mystery":
      return {
        title: `🎁 Secret Challenge: ${opts.competitionName}`,
        text: `🤫 ${opts.inviterName} sent you a secret challenge. Open to find out →`,
        url,
      };
    default:
      return {
        title: `🏆 Step Challenge: ${opts.competitionName}`,
        text: `👋 ${opts.inviterName} challenged you to a step competition! Can you keep up?`,
        url,
      };
  }
}
